import React from "react";

const OFSBackSortPrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-40">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy for OFS BackSort</h1>
      <p className="mb-4"><strong>Effective Date:</strong> 16-04-2025</p>
      <p className="mb-6">
        Welcome to OFS BackSort! Your privacy is important to us, and we are committed to
        protecting any personal information you share with us. This Privacy Policy outlines
        how we collect, use, and protect your data when you use our Shopify app.
      </p>

      <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
      <p className="mb-2">When you install and use the OFS BackSort app, we may collect the following types of information:</p>

      <h3 className="text-xl font-medium mb-2">1.1 Shopify Store Information</h3>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Store name</li>
        <li>Store URL</li>
        <li>Shopify store ID</li>
        <li>Shopify plan details</li>
      </ul>

      <h3 className="text-xl font-medium mb-2">1.2 User Information</h3>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Shopify account email</li>
        <li>Store owner name (if applicable)</li>
        <li>Contact details provided via customer support</li>
      </ul>

      <h3 className="text-xl font-medium mb-2">1.3 App Usage Data</h3>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Collections and product sorting preferences</li>
        <li>Inventory and stock-related data for sorting</li>
        <li>Activity logs for feature usage</li>
      </ul>
      <p className="mb-6">
        <strong>Note:</strong> We do not collect or store customer payment information, financial data,
        or sensitive personal information from your Shopify store.
      </p>

      <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Provide and improve the OFS BackSort app functionality</li>
        <li>Enable sorting and management of collections based on inventory and sorting rules</li>
        <li>Offer customer support and respond to inquiries</li>
        <li>Improve app performance and user experience</li>
        <li>Monitor system stability and troubleshoot technical issues</li>
      </ul>
      <p className="mb-6">
        We do not sell or share your data with third parties for marketing purposes.
      </p>

      <h2 className="text-2xl font-semibold mb-4">3. Data Storage & Security</h2>
      <p className="mb-6">
        We store your data securely on encrypted servers and implement industry-standard
        security measures to prevent unauthorized access, disclosure, or modification
        of your data. While we strive to protect your data, no method of transmission
        over the internet is 100% secure, and we cannot guarantee absolute security.
      </p>

      <h2 className="text-2xl font-semibold mb-4">4. Third-Party Services</h2>
      <p className="mb-6">
        OFS BackSort integrates with Shopify and relies on its API to access store data.
        Shopify's privacy policies apply when using our app. Please review Shopify’s
        policies for details. If any additional third-party services are integrated,
        we will ensure they comply with relevant data protection regulations.
      </p>

      <h2 className="text-2xl font-semibold mb-4">5. Data Retention & Deletion</h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>We retain data as long as necessary to provide our services.</li>
        <li>If you uninstall OFS BackSort, your store data will be deleted within 30 days unless required for legal or compliance purposes.</li>
        <li>You can request data deletion by contacting our support team at <a href="mailto:support@mean3.com" className="text-blue-500 hover:underline">support@mean3.com</a>.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">6. Your Rights</h2>
      <p className="mb-2">You have the right to:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Access and review the data we store about you</li>
        <li>Request corrections or modifications to your stored data</li>
        <li>Request deletion of your data (subject to legal obligations)</li>
      </ul>
      <p className="mb-6">For any requests, please contact us at <a href="mailto:support@mean3.com" className="text-blue-500 hover:underline">support@mean3.com</a>.</p>

      <h2 className="text-2xl font-semibold mb-4">7. Cookies & Tracking Technologies</h2>
      <p className="mb-6">
        We do not use cookies for tracking user behavior. However, Shopify may use cookies in
        relation to our app's operation. Please refer to Shopify’s cookie policy for details.
      </p>

      <h2 className="text-2xl font-semibold mb-4">8. Changes to This Policy</h2>
      <p className="mb-6">
        We may update this Privacy Policy from time to time. Any changes will be posted on
        this page with an updated effective date. If changes significantly affect your rights,
        we will notify you via email or an app notification.
      </p>

      <h2 className="text-2xl font-semibold mb-4">9. Contact Us</h2>
      <p className="mb-2">If you have any questions about this Privacy Policy, please contact us:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li><strong>Email:</strong> <a href="mailto:support@mean3.com" className="text-blue-500 hover:underline">support@mean3.com</a></li>
      </ul>
    </div>
  );
};

export default OFSBackSortPrivacyPolicy;
